import React, { useState, useEffect, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { consultar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'

const Consulta = (props) => {
    const [data, setData] = useState([])
    const [pageIndex, setPageIndex] = useState()
    const [qtdRegistros, setQtdRegistros] = useState()

    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-auditoria',
                qtdRegistros: qtdRegistros,
                paginacaoManual: true,
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Usuário',
                        accessor: 'usuario',
                        filtro: {
                            combo:'combo',
                            tipo: 'usuario_auditoria',
                            idColuna: 'usuario_id'
                        },
                        ordenamento: {
                            tipo: 'texto',
                        }
                    },
                    {
                        Header: 'Ação',
                        accessor: 'acao',
                        ordenamento: {
                            tipo: 'combo',
                        },
                        filtro: {
                            combo:'combo-alternativa',
                            tipo: 'acoes',
                            idColuna: 'acao.id'
                        },
                    },
                    {
                        Header: 'Módulo',
                        accessor: 'modulo',
                        ordenamento: {
                            tipo: 'combo',
                        },
                        visivel: false,
                        filtro: {
                            combo:'combo-alternativa',
                            tipo: 'modulo',
                            idColuna: 'modulo.id'
                        },
                        filtroSomenteModal: true
                    },
                    {
                        Header: 'Data  Ação',
                        accessor: 'data_acao',
                        ordenamento: {
                            tipo: 'data',
                        },
                        classeThead: 'teste semAcoes',
                        classeTd: 'teste semAcoes',
                        filtro: {
                            combo:'combo-simples',
                            idColuna: 'auditoria.data_registro',
                            tipo: 'data_inicial'
                        },
                    },
                    
                ]
            }], []
    )

    const semAcoesObj = []

    return (
        <>
            <div>
                <DataGridAlternativa data={data} columns={columns} setData={setData} acoesObj={semAcoesObj} acoes={false} caminhoBase='/controleAcesso/auditoria'
                    tituloLista={'Lista Auditoria'} setPageIndex={setPageIndex} setQtdRegistros={setQtdRegistros} caminhoConsultaFiltros='/controleAcesso/auditoria'
                    modulo={props.modulo} titulo={'Consulta Auditoria'} icone={'icon-Business-ManWoman'} />
            </div>
        </>
    )
}

export default Consulta